<template>
  <div class="login-page">
    <header class="site-header">
      <div class="service-bar">
        <div class="shell service-bar-inner">
          <div class="service-copy">
            <span class="service-label">{{ $t("login.service.label") }}</span>
            <span class="service-message">{{ $t("login.service.message") }}</span>
          </div>
          <LanguageSwitcher />
        </div>
      </div>

      <div class="brand-bar">
        <div class="shell brand-bar-inner">
          <div class="brand-lockup" aria-label="VLECAD Insights">
            <img
              class="brand-logo"
              src="/logo-vlecad-horizontal.svg"
              alt="VLECAD®"
              width="611"
              height="181"
            />
            <span class="brand-divider" aria-hidden="true"></span>
            <span class="product-name">Insights</span>
          </div>

          <div class="account-area">
            <div v-if="authState.isAuthenticated" class="account-details">
              <span class="login-name">{{ loginName }}</span>
              <span class="login-number">{{ $t("login.account.customer", { number: loginNumber }) }}</span>
            </div>
            <button v-if="!authState.isAuthenticated" class="login-button" type="button" @click="login">
              {{ $t("login.actions.login") }}
            </button>
          </div>
        </div>
      </div>
    </header>

    <main class="login-hero">
      <div class="hero-geometry" aria-hidden="true">
        <span class="hexagon hexagon-large"></span>
        <span class="hexagon hexagon-medium"></span>
        <span class="hexagon hexagon-small"></span>
      </div>

      <div class="shell hero-grid">
        <section class="hero-copy" aria-labelledby="insights-title">
          <p class="eyebrow">{{ $t("login.hero.eyebrow") }}</p>
          <h1 id="insights-title">{{ $t("login.hero.title") }}</h1>
          <p class="hero-intro">{{ $t("login.hero.intro") }}</p>
          <ul class="benefit-list">
            <li><span aria-hidden="true">✓</span> {{ $t("login.hero.benefits.reporting") }}</li>
            <li><span aria-hidden="true">✓</span> {{ $t("login.hero.benefits.tailored") }}</li>
            <li><span aria-hidden="true">✓</span> {{ $t("login.hero.benefits.secure") }}</li>
          </ul>
        </section>

        <div v-if="showLoginModal" class="modal-overlay" @click.self="showLoginModal = false">
          <section class="modal" aria-labelledby="login-title">
            <p class="card-eyebrow">{{ $t("login.form.access") }}</p>
            <h2 id="login-title">{{ $t("login.form.title") }}</h2>
            <p class="card-intro">{{ $t("login.form.intro") }}</p>

            <form @submit.prevent="handleLogin">
              <div class="form-group">
                <label for="username">{{ $t("login.form.username") }}</label>
                <input
                  id="username"
                  v-model="username"
                  type="text"
                  autocomplete="username"
                  :aria-invalid="showError ? 'true' : undefined"
                  :aria-describedby="showError ? 'login-error' : undefined"
                />
              </div>
              <div class="form-group">
                <label for="password">{{ $t("login.form.password") }}</label>
                <input
                  id="password"
                  v-model="password"
                  type="password"
                  autocomplete="current-password"
                  :aria-invalid="showError ? 'true' : undefined"
                  :aria-describedby="showError ? 'login-error' : undefined"
                />
              </div>

              <p class="register-copy">
                <a
                  href="#"
                  class="decorationNone"
                  :aria-label="$t('login.form.wordpressLogin')"
                  @click.prevent="loginWP"
                >{{ $t("login.form.registrationTrigger") }}</a><span>{{ $t("login.form.registrationText") }} </span>
                <a href="https://my.vlecad.be/register">{{ $t("login.form.registrationSite") }}</a>
              </p>

              <div class="form-actions">
                <button type="submit" class="modal-button">{{ $t("login.actions.login") }}</button>
                <button type="button" class="modal-button-annuleren" @click="showLoginModal = false">
                  {{ $t("login.actions.cancel") }}
                </button>
              </div>

              <div v-if="showError" id="login-error" class="error" role="alert" aria-live="assertive">
                {{ message }}
              </div>
            </form>
          </section>
        </div>

        <aside v-else class="login-return" aria-labelledby="login-return-title">
          <span class="login-return-mark" aria-hidden="true">V</span>
          <h2 id="login-return-title">{{ $t("login.returnCard.title") }}</h2>
          <p>{{ $t("login.returnCard.intro") }}</p>
          <button class="modal-button" type="button" @click="login">{{ $t("login.actions.signIn") }}</button>
        </aside>
      </div>
    </main>
  </div>
</template>

<script>
import { useAuth } from "@/store/auth";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
//import { loginUser } from '@/services/authService';
import AuthService from "../services/authService";

export default {
  name: "LoginPage",
  components: {
    LanguageSwitcher,
  },
  setup() {
    const { authState, logout } = useAuth();
    return {
      authState,
      logout,
    }
  },
  data() {
    return {
      username: "",
      password: "",
      showError: false,
      messageKey: "",
      showLoginModal: true,
      customerId: null,
      loginName: "",
      loginNumber: "",
      loginUserWP: false,
      isAdmin: false
    };
  },
  computed: {
    message() {
      return this.messageKey ? this.$t(this.messageKey) : "";
    },
  },
  methods: {
    loginWP() {
      console.log("loginWP");
      this.loginUserWP = true;
      this.handleLogin();
    },
    login() {
      console.log("login");
      this.showLoginModal = true;
      this.loginUserWP = false;
    },
    async handleLogin() {
      try {
        console.log("handleLogin");
        this.showError = false;
        this.messageKey = "";
  
        //const userData = await loginUser(this.username, this.password);
        let userData = {};
        if(this.loginUserWP) {
          userData = await AuthService.loginUserWP(this.username, this.password);
        }
        else {
          userData = await AuthService.loginUser(this.username, this.password);
        }
        
        console.log("userData: " + JSON.stringify(userData));
        //if(userData.message != null && userData.message != "") {
        //if(this.username === "vlecad" && this.password === "vlecad") {
        if(userData.status === 200) {
          if(userData.email.endsWith('@vlecad.be')) this.isAdmin = true;
          console.log("isAdmin: " + this.isAdmin);
          localStorage.setItem("isAdmin", this.isAdmin);
          this.loginName = userData.name;
          this.loginNumber = userData.cid;
          this.showError = false;
          this.messageKey = "";
          const { login } = useAuth();
          this.customerId = userData.cid;

          const response = await AuthService.getAUC(this.customerId, this.baseUrl);
          const auc = response.XAUC;
          const aucED = response.XAUC_EXPIRE_DATE;
          console.log("response: " + JSON.stringify(response));
          console.log("auc: " + auc);
          console.log("auc date: " + aucED);

          if(auc !== undefined) {
            //const [day, month, year] = aucED.split("/");
            //const expireDate = new Date(`${year}-${month}-${day}`);
            const expireDate = new Date(aucED);
            const currentDate = new Date();
            console.log("expireDate: " + expireDate);
            console.log("currentDate: " + currentDate);

            if(expireDate >= currentDate) {
              if(auc.includes('Platinum')) {
                localStorage.setItem("version", "Versie 2");
                login(this.username, this.customerId, this.loginName, this.loginNumber);
                this.$router.push("/"); // Stuur de gebruiker naar de homepage
              }
              else {
                const respFBInsights = await AuthService.getFBInsights();
                console.log("respFBInsights: " + JSON.stringify(respFBInsights));
                console.log("status: " + respFBInsights.status);
                if(respFBInsights.status === 200) {
                  const version = this.searchAuc(respFBInsights.data, auc);
                  localStorage.setItem("version", version);
                  console.log("-------------------");
                  console.log("gevonden: " + version);
                  console.log("-------------------");
                  login(this.username, this.customerId, this.loginName, this.loginNumber);
                  this.$router.push("/"); // Stuur de gebruiker naar de homepage
                }
                else {
                  this.showError = true;
                  this.messageKey = "login.errors.insightsData";
                }
              }
            }
            else {
              this.showError = true;
              this.messageKey = "login.errors.contractExpired";
            }
          }
          else {
            this.showError = true;
            this.messageKey = "login.errors.contractFetch";
          }
        }
        else {
          this.showError = true;
          //this.message = userData.message;
          console.log("login error: " + userData.message);
          this.messageKey = "login.errors.authenticationFailed";
        }
      } 
      catch (error) {
        console.error("handleLogin error", error);
        alert(this.$t("login.errors.unexpected"));
      }
    },
    searchAuc(data, auc) {
      const itemAuc = data.find(item => item.auc === auc);
      return itemAuc ? itemAuc.description : "null";
    },

  },
};
</script>

<style scoped>
.login-page {
  --color-navy: #12364a;
  --color-heading: #3d4049;
  --color-text: #4d535c;
  --color-muted: #696f78;
  --color-blue: #0d74ac;
  --color-blue-dark: #095f8d;
  --color-blue-light: #dcecf4;
  --color-gold: #bf9c59;
  --color-gold-light: #d5be8d;
  --color-border: #d9dde0;
  --color-background: #f4f5f4;
  --color-surface: #ffffff;
  --color-error: #a72727;
  --shadow-card: 0 18px 44px rgba(30, 52, 65, 0.14);
  --radius-small: 0.3rem;
  --radius-large: 0.85rem;
  --content-width: 75rem;
  --hexagon: polygon(25% 0, 75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%);
  min-width: 20rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--color-text);
  background: var(--color-surface);
  font-family: "Fredoka", "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 1rem;
  line-height: 1.55;
}

.login-page,
.login-page * {
  box-sizing: border-box;
}

.shell {
  width: min(calc(100% - 4rem), var(--content-width));
  margin-inline: auto;
}

.site-header {
  position: relative;
  z-index: 10;
  flex: 0 0 auto;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface);
}

.site-header::after {
  content: "";
  position: absolute;
  right: max(2rem, calc((100vw - var(--content-width)) / 2));
  bottom: -1px;
  width: 4.5rem;
  height: 3px;
  background: linear-gradient(90deg, var(--color-blue) 0 62%, var(--color-gold) 62% 100%);
}

.service-bar {
  min-height: 2.75rem;
  display: flex;
  align-items: center;
  color: #ffffff;
  background: var(--color-blue-dark);
  font-size: 0.85rem;
}

.service-bar-inner,
.brand-bar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.service-bar-inner {
  min-height: 2.75rem;
  gap: 1.5rem;
}

.service-copy {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.service-label {
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.service-message {
  color: rgba(255, 255, 255, 0.84);
}

.brand-bar {
  background: rgba(255, 255, 255, 0.98);
}

.brand-bar-inner {
  min-height: 5rem;
  gap: 2rem;
}

.brand-lockup {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.brand-logo {
  width: clamp(10rem, 18vw, 13.25rem);
  height: auto;
  display: block;
}

.brand-divider {
  width: 1px;
  height: 2.25rem;
  flex: 0 0 auto;
  background: var(--color-border);
}

.product-name {
  color: var(--color-navy);
  font-size: 1.15rem;
  font-weight: 600;
  letter-spacing: 0.035em;
}

.account-area,
.account-details {
  display: flex;
  align-items: center;
}

.account-area {
  justify-content: flex-end;
}

.account-details {
  gap: 0.85rem;
  color: var(--color-navy);
  font-size: 0.9rem;
}

.login-name {
  font-weight: 600;
}

.login-number {
  padding-left: 0.85rem;
  border-left: 1px solid var(--color-border);
  color: var(--color-muted);
}

.login-button,
.modal-button,
.modal-button-annuleren {
  min-height: 2.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.72rem 1.15rem;
  border: 2px solid transparent;
  border-radius: var(--radius-small);
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  line-height: 1.2;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.login-button,
.modal-button {
  color: var(--color-navy);
  border-color: var(--color-gold);
  background: var(--color-gold);
}

.login-button:hover,
.modal-button:hover {
  border-color: var(--color-gold-light);
  background: var(--color-gold-light);
  transform: translateY(-2px);
}

.login-hero {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-block: clamp(3.5rem, 7vw, 6.5rem);
  border-bottom: 1px solid var(--color-border);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.99) 0 53%, rgba(220, 236, 244, 0.82) 53% 100%);
}

.login-hero::before {
  content: "";
  position: absolute;
  right: -12rem;
  bottom: -15rem;
  width: 46rem;
  height: 30rem;
  pointer-events: none;
  clip-path: polygon(11% 0, 89% 0, 100% 50%, 89% 100%, 11% 100%, 0 50%);
  background: rgba(13, 116, 172, 0.1);
}

.hero-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(22rem, 27rem);
  gap: clamp(3rem, 7vw, 6rem);
  align-items: center;
}

.hero-copy {
  max-width: 42rem;
}

.eyebrow,
.card-eyebrow {
  margin: 0 0 0.65rem;
  color: var(--color-blue-dark);
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.hero-copy h1,
.modal h2,
.login-return h2 {
  margin-top: 0;
  color: var(--color-heading);
  font-weight: 600;
  line-height: 1.12;
  letter-spacing: -0.025em;
}

.hero-copy h1 {
  max-width: 11ch;
  margin-bottom: 1.5rem;
  font-size: clamp(2.5rem, 5vw, 4rem);
}

.hero-copy h1::after {
  content: "";
  width: 5.5rem;
  height: 0.28rem;
  display: block;
  margin-top: 1.25rem;
  background: linear-gradient(90deg, var(--color-gold) 0 62%, var(--color-blue) 62% 100%);
}

.hero-intro {
  max-width: 39rem;
  margin: 0 0 1.6rem;
  color: var(--color-text);
  font-size: clamp(1.08rem, 2vw, 1.3rem);
}

.benefit-list {
  display: grid;
  gap: 0.7rem;
  margin: 0;
  padding: 0;
  color: var(--color-navy);
  list-style: none;
}

.benefit-list li {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-weight: 500;
}

.benefit-list span {
  width: 1.55rem;
  height: 1.35rem;
  display: inline-grid;
  flex: 0 0 auto;
  place-items: center;
  clip-path: var(--hexagon);
  color: #ffffff;
  background: var(--color-blue);
  font-size: 0.72rem;
  font-weight: 700;
}

.hero-geometry {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}

.hexagon {
  position: absolute;
  display: block;
  clip-path: var(--hexagon);
}

.hexagon-large {
  top: -5.5rem;
  left: 46%;
  width: 15rem;
  height: 13rem;
  transform: rotate(8deg);
  background: rgba(191, 156, 89, 0.18);
}

.hexagon-medium {
  right: 5%;
  bottom: 7%;
  width: 8.5rem;
  height: 7.4rem;
  background: rgba(13, 116, 172, 0.09);
}

.hexagon-small {
  left: 47%;
  bottom: 8%;
  width: 4.25rem;
  height: 3.7rem;
  background: rgba(191, 156, 89, 0.24);
}

.modal-overlay {
  width: 100%;
  display: grid;
  align-items: center;
}

.modal,
.login-return {
  position: relative;
  width: 100%;
  padding: clamp(1.75rem, 4vw, 2.5rem);
  overflow: hidden;
  border: 1px solid rgba(18, 54, 74, 0.12);
  border-radius: var(--radius-large);
  background: var(--color-surface);
  box-shadow: var(--shadow-card);
}

.modal::before,
.login-return::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 0.3rem;
  background: linear-gradient(90deg, var(--color-gold) 0 62%, var(--color-blue) 62% 100%);
}

.modal::after,
.login-return::after {
  content: "";
  position: absolute;
  top: -3.25rem;
  right: -3.4rem;
  width: 8.5rem;
  height: 7.4rem;
  pointer-events: none;
  clip-path: var(--hexagon);
  background: rgba(220, 236, 244, 0.72);
}

.modal > *,
.login-return > * {
  position: relative;
  z-index: 1;
}

.modal h2,
.login-return h2 {
  margin-bottom: 0.65rem;
  font-size: clamp(1.75rem, 3vw, 2.25rem);
}

.card-intro,
.login-return p {
  margin: 0 0 1.65rem;
  color: var(--color-muted);
}

.form-group {
  margin-bottom: 1.15rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.45rem;
  color: var(--color-navy);
  font-size: 0.94rem;
  font-weight: 600;
}

.form-group input {
  width: 100%;
  min-height: 3.15rem;
  padding: 0.7rem 0.85rem;
  border: 1px solid #b9c1c6;
  border-radius: var(--radius-small);
  color: var(--color-heading);
  background: #ffffff;
  font: inherit;
  font-size: 1rem;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-group input:hover {
  border-color: var(--color-blue);
}

.form-group input:focus-visible,
.login-button:focus-visible,
.modal-button:focus-visible,
.modal-button-annuleren:focus-visible,
.register-copy a:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow: 0 0 0 3px #ffffff, 0 0 0 6px var(--color-blue);
}

.form-group input[aria-invalid="true"] {
  border-color: var(--color-error);
}

.register-copy {
  margin: 0.25rem 0 1.4rem;
  color: var(--color-muted);
  font-size: 0.9rem;
}

.register-copy a {
  color: var(--color-blue-dark);
  font-weight: 600;
  text-decoration-thickness: 0.08em;
  text-underline-offset: 0.18em;
}

.register-copy .decorationNone {
  color: inherit;
  font-weight: inherit;
  text-decoration: none;
}

.form-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.modal-button-annuleren {
  color: var(--color-blue-dark);
  border-color: currentColor;
  background: transparent;
}

.modal-button-annuleren:hover {
  color: #ffffff;
  background: var(--color-blue-dark);
  transform: translateY(-2px);
}

.error {
  margin-top: 1.15rem;
  padding: 0.75rem 0.85rem;
  border-left: 0.28rem solid var(--color-error);
  border-radius: var(--radius-small);
  color: #711c1c;
  background: #fbeaea;
  font-size: 0.92rem;
  font-weight: 500;
}

.login-return {
  text-align: center;
}

.login-return-mark {
  width: 5rem;
  height: 4.35rem;
  display: grid;
  margin: 0 auto 1.5rem;
  place-items: center;
  clip-path: var(--hexagon);
  color: var(--color-navy);
  background: linear-gradient(135deg, var(--color-gold) 0 38%, var(--color-blue-light) 38% 100%);
  font-size: 2rem;
  font-weight: 600;
}

.login-return .modal-button {
  width: 100%;
}

@media (max-width: 56rem) {
  .hero-grid {
    grid-template-columns: 1fr;
    gap: 2.75rem;
  }

  .hero-copy {
    max-width: 44rem;
  }

  .hero-copy h1 {
    max-width: 14ch;
  }

  .modal-overlay,
  .login-return {
    width: min(100%, 34rem);
    justify-self: center;
  }

  .hexagon-large {
    left: auto;
    right: -3rem;
  }

  .hexagon-small {
    left: 5%;
    bottom: 3%;
  }
}

@media (max-width: 40rem) {
  .shell {
    width: min(calc(100% - 2rem), var(--content-width));
  }

  .service-message {
    display: none;
  }

  .service-bar-inner {
    justify-content: center;
  }

  .brand-bar-inner {
    min-height: 4.5rem;
    gap: 1rem;
  }

  .brand-logo {
    width: 9.25rem;
  }

  .brand-divider {
    height: 1.75rem;
  }

  .product-name {
    font-size: 1rem;
  }

  .login-button {
    min-height: 2.5rem;
    padding: 0.55rem 0.8rem;
    font-size: 0.9rem;
  }

  .account-details {
    display: grid;
    gap: 0;
    text-align: right;
  }

  .login-number {
    padding-left: 0;
    border-left: 0;
  }

  .login-hero {
    align-items: flex-start;
    padding-block: 3rem;
    background: linear-gradient(155deg, #ffffff 0 43%, rgba(220, 236, 244, 0.82) 43% 100%);
  }

  .hero-grid {
    gap: 2.25rem;
  }

  .hero-copy h1 {
    font-size: clamp(2.25rem, 12vw, 3.15rem);
  }

  .benefit-list {
    font-size: 0.94rem;
  }

  .modal,
  .login-return {
    padding: 1.6rem 1.25rem;
  }

  .form-actions {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 27rem) {
  .brand-lockup {
    gap: 0.65rem;
  }

  .brand-logo {
    width: 7.75rem;
  }

  .brand-divider,
  .product-name {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .login-button,
  .modal-button,
  .modal-button-annuleren,
  .form-group input {
    transition: none;
  }
}
</style>
